import React, { useState } from 'react';
import FrameworkContractSC from './framework-contract.styled';
import Button from '../../ui/button';
import { BiggerText, SmallText } from '../../typography';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import DocumentsVerification from '../documents-verification';

const FrameworkContract = ({ onClick, documents, disabled }) => {
  const [areAllRead, setAllRead] = useState(false);

  const setDocumentsToAllRead = (status) => {
    setAllRead(status);
  };

  return (
    <FrameworkContractSC>
      <DocumentsVerification
        documents={documents}
        setDocumentsToAllRead={(status) => setDocumentsToAllRead(status)}
      />
      <div className="bottom-wrap">
        <BiggerText>
          <FormattedHTMLMessage
            id="onboarding_continue_hint"
            defaultMessage={dlt['onboarding_continue_hint']}
          />
        </BiggerText>
        <Button
          type="PRIMARY"
          disabled={areAllRead && !disabled ? false : true}
          withIcon
          onClick={onClick}
        >
          <FormattedMessage id="global_continue" defaultMessage={dlt['global_continue']} />
        </Button>
        <SmallText className="black-transparent">
          <FormattedMessage
            id="onboarding_documents_hint"
            defaultMessage={dlt['onboarding_documents_hint']}
          />
        </SmallText>
      </div>
    </FrameworkContractSC>
  );
};

export default FrameworkContract;
